module.exports = __webpack_public_path__ + "static/media/dochub.b09f053a.svg";